import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseModalComponent } from '@card-software/library';
import { Representative } from '../../../../models/representative/representative';

@Component({
  selector: 'app-representative-details-modal',
  templateUrl: './representative-details-modal.component.html',
})
export class RepresentativeDetailsModalComponent extends BaseModalComponent<Representative | null> implements OnInit {
  @Input() representative: Representative | null = null;
  @Input() viewOnly = false;

  representativeForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    injector: Injector,
  ) {
    super(injector);

    this.representativeForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNumber: [''],
      email: ['', Validators.email],
    });
  }

  ngOnInit(): void {
    if (this.representative) {
      this.representativeForm.patchValue(this.representative);
    }
  }
  onSave() {
    if (this.representativeForm.invalid) return;

    const formValue = this.representativeForm.value;

    this.close({
      action: 'Save',
      data: {
        ...formValue,
        ...(this.representative?.id ? { id: this.representative.id } : {}),
      },
    });
  }

  onClose() {
    this.close({ action: 'Cancel', data: null });
  }
}
